import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

/**
 * The function first converts the name to uppercase and splits the string by
 * the "at" symbol. It then splits the resulting string by various delimiters,
 * such as ".", "-", "_", and " ", and creates an abbreviation by taking the
 * first letter of each word in the name. If the onlyFirstAndLast flag is set to
 * true, the function will return only the first and last letters of the
 * abbreviation, otherwise it will return the full abbreviation.
 */
var getInitials = function getInitials(name, onlyFirstAndLast) {
  var _name$toUpperCase$spl = name.toUpperCase().split('@'),
    _name$toUpperCase$spl2 = _slicedToArray(_name$toUpperCase$spl, 1),
    parsedText = _name$toUpperCase$spl2[0];
  var splitTexts = parsedText.split(/[.\-_ ]/g);
  var abbr = splitTexts.map(function (t) {
    return t[0];
  }).join('');
  if (onlyFirstAndLast) return "".concat(abbr[0]).concat(abbr[abbr.length - 1]);
  return abbr;
};

export { getInitials };
